<script>
import { Bar } from "vue-chartjs";
import GraficasService from "@services/GraficasService";

export default {
    extends: Bar,
    props: ["labels", "dataset", "opciones"],
    data: () => ({
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true,
                        },
                    },
                ],
            },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        let dataset = data.datasets[tooltipItem.datasetIndex];
                        let label = dataset.label || "";

                        if (label) {
                            label += ": ";
                        }

                        let valorConSeparadores = GraficasService.addSeparadores(
                            tooltipItem.yLabel
                        );

                        label += `${valorConSeparadores} ${dataset.unit_label}`;
                        return label;
                    },
                },
            },
        },
        datasets: [],
        colores: [
            "#FDC20B",
            "#35BDE6",
            "#EB5C63",
            "#8BC8A1",
            "#93891C",
            "#3870B6",
            "#F8AD23",
            "#4ABBC1",
            "#C2C23A",
        ],
    }),
    methods: {
        getArrayColores() {
            let arrayColores = [];
            for (let i = 0; i < this.dataset[0].datos.length; i++) {
                arrayColores.push(this.colores[i % 9]);
            }
            return arrayColores;
        },

        getColorSegunOpcion(i) {
            if (
                this.opciones != null &&
                this.opciones.includes("alternar_color_barras")
            ) {
                return this.getArrayColores();
            } else {
                return this.colores[i % 9];
            }
        },
    },

    mounted() {
        for (var i = 0; i < this.dataset.length; i++) {
            this.datasets.push({
                label: this.dataset[i].etiqueta,
                backgroundColor: this.getColorSegunOpcion(i),
                data: this.dataset[i].datos,
                unit_label: this.dataset[i].etiqueta_unidad,
            });
        }

        if (this.opciones != null) {
            let grafserv = new GraficasService();
            grafserv.modificarOptions(this.opciones, this.options);
        }

        this.renderChart(
            {
                labels: this.labels,
                datasets: this.datasets,
            },
            this.options
        );
    },
};
</script>
